import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);

axios.defaults.timeout = 3000;
axios.defaults.baseURL = process.env.VUE_APP_APIPATH;
axios.defaults.headers.common.Accept = 'application/json';


export default axios;
